import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Spinner, Warning, CheckCircle } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/errors";

export default function MagicConsume() {
  const { consumeMagicToken } = useAuth();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("checking"); // checking | error | success
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState("error");
      setErrorMsg("No sign-in token in the link.");
      return;
    }
    (async () => {
      try {
        await consumeMagicToken(token);
        setState("success");
        toast.success("Signed in.");
        setTimeout(() => nav("/start", { replace: true }), 800);
      } catch (err) {
        setState("error");
        setErrorMsg(apiError(err, "Could not sign you in"));
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="max-w-md mx-auto px-6 sm:px-8 py-24 text-center">
      {state === "checking" && (
        <div className="anim-in delay-1" data-testid="magic-checking">
          <Spinner size={28} className="animate-spin text-[#1E3A2B] mx-auto mb-4" />
          <h1 className="font-serif text-2xl text-[#1E3A2B]">Signing you in…</h1>
          <p className="text-sm text-[#8A948E] mt-2">One moment.</p>
        </div>
      )}
      {state === "success" && (
        <div className="anim-in delay-1" data-testid="magic-success">
          <CheckCircle size={36} weight="duotone" className="text-[#1E3A2B] mx-auto mb-4" />
          <h1 className="font-serif text-2xl text-[#1E3A2B]">Welcome back.</h1>
          <p className="text-sm text-[#8A948E] mt-2">Taking you to your conversations…</p>
        </div>
      )}
      {state === "error" && (
        <div className="anim-in delay-1" data-testid="magic-error">
          <Warning size={36} weight="duotone" className="text-[#C77D5E] mx-auto mb-4" />
          <h1 className="font-serif text-2xl text-[#1E3A2B]">Sign-in failed.</h1>
          <p className="text-sm text-[#4A524C] mt-2">{errorMsg}</p>
          <button
            onClick={() => nav("/auth/login")}
            className="mt-6 inline-flex items-center gap-2 bg-[#1E3A2B] text-white px-5 py-2.5 rounded-xl hover:bg-[#2C4C3B]"
          >
            Try again
          </button>
        </div>
      )}
    </div>
  );
}
